module.exports = __webpack_public_path__ + "img/hippo.53411ea2.svg";